import { ViewportBreakpoint } from '@constants';
import useViewportSize from './useViewportSize';

const useIsMobile = () => {
  const viewportSize = useViewportSize();
  return viewportSize <= ViewportBreakpoint.Mobile;
};

export default useIsMobile;
